import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import Tabla from '../../componentes/Table';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import Default from '../../contenedores/Default';
import endpoints, {
  NIVELESPOLINIZACION,
  SECCIONES,
} from '../../configuraciones/endpoints';

import { DatePickerTypes } from '../../constantes/datePickerTypes';

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Polinizaciones',
  data: [
    {
      id: 1,
      nombre: 'Polinizaciones detallado',
      subTitle: 'Listado por nivel.',
    },
    {
      id: 2,
      nombre: 'Polinizaciones agrupado',
      subTitle: 'Listado por nivel.',
    },
  ],
};

const cabeceros = [
  { label: 'SITIO', key: 'sitio', align: 'left' },
  { label: 'INVERNADERO', key: 'invernadero', align: 'left' },
  { label: 'NAVE', key: 'Nave', align: 'left' },
  { label: 'SECCIÓN', key: 'Seccion', align: 'left' },
  { label: 'NIVEL', key: 'Nivel', align: 'left' },
  { label: 'FLORES', key: 'flores', align: 'left' },
];

const ReportePolinizacionDetallado = ({ history }) => {
  const { registros } = useSelector((store) => store.listados);
  const { data, formData, onChange, onDelete, buscar } = useFetchReporte(
    {
      secciones: endpoints.base.busqueda(SECCIONES),
      niveles: endpoints.base.busqueda(NIVELESPOLINIZACION),
    },
    endpoints.reportePolinizaciones(),
  );

  const handleTodosSelected = useCallback(() => {
    const { sitios, invernaderos, naves, niveles, secciones, fecha } = formData;

    const params = {
      sitios,
      invernaderos,
      naves,
      secciones,
      niveles,
      fecha: moment(fecha).format('W-GGGG'),
    };
    return params;
  }, [formData]);

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/polinizacion/detallado`);
    } else {
      history.push(`/reportes/polinizacion/agrupado`);
    }
  };

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion
          datosLista={datosLista}
          onClick={onSubMenuClick}
          initOpcion={0}
        />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 4, show: true },
          invernadero: { width: 4, show: true },
          nave: { width: 4, show: true },
          seccion: { width: 3, show: true },
          nivel: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.week },
        }}
        endpoint={endpoints.reportePolinizaciones()}
        method="POST"
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
    </Default>
  );
};

export default ReportePolinizacionDetallado;
